"use client";
import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";

const VeppleTourEmbed = dynamic(() => import("./vepple-tour-embed"), {
  ssr: false,
});

interface VeppleInterface {
  id: string;
  url: string;
  uniInfo: any;
  enquiry: any;
  page_section?:string;
}

const VeppleClientWrapper = ({
  id,
  url,
  uniInfo,
  enquiry,
  page_section
}: VeppleInterface) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [triggerEffect, setTriggerEffect] = useState(false);
  useEffect(() => {
    if (!wrapperRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (shouldLoad) {
      const script = document.createElement("script");
      script.src = "https://rv-vepple-tour.web.app/vepple-tour.min.js";
      script.type = "module";
      script.async = true;
      document.body.appendChild(script);
      setTriggerEffect(true);
    }
  }, [shouldLoad]);

  useEffect(() => {
    if (!triggerEffect) return;
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [triggerEffect]);

  return (
    <>
      <div
      id="vepple"
        ref={wrapperRef}
        className={
          isLoading && triggerEffect
            ? "skeleton skeleton-text-animated skeleton-square-img !w-[100%] !h-[500px]"
            : ""
        }
      >
        {shouldLoad && triggerEffect && (
          <VeppleTourEmbed
            id={id}
            url={url}
            uniInfo={uniInfo}
            enquiry={enquiry}
            page_section={page_section}
          />
        )}
      </div>
    </>
  );
};

export default VeppleClientWrapper;
